import React, { Component } from "react";
import { Typography /* Button */ } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { userSignout } from "../../../actions";
import { connect } from "react-redux";

class AuthenticationFailed extends Component {
  componentDidMount() {
    this.props.dispatch(userSignout());
  }

  render() {
    return (
      <Paper align="center" square elevation={0}>
        <Typography variant="h4" align="center">
          Authentication failed
        </Typography>
        <Typography>Please login again.</Typography>
        <Button color="primary" variant="outlined" component={Link} to="/login">
          Sign in
        </Button>
      </Paper>
    );
  }
}

export default connect()(AuthenticationFailed);
